/**
 * Path fixes for old WordPress / legacy URLs (see console errors/ GSC exports).
 */

const LANG = "ga|de|es|it|no|fi|da|sv|fr|pt|nl|uk|au|at";
const LANG_PREFIX = new RegExp(`^/(${LANG})(/|$)`);

function prefixLang(lang, path) {
  const clean = path.startsWith("/") ? path : `/${path}`;
  if (!lang) return clean;
  if (clean === "/") return `/${lang}`;
  return `/${lang}${clean}`;
}

/**
 * @param {string} pathname
 * @returns {string|null} New pathname or null
 */
export function getLegacyRedirectPath(pathname) {
  if (!pathname) return null;
  const path = pathname.length > 1 && pathname.endsWith("/") ? pathname.slice(0, -1) : pathname;
  const langMatch = path.match(LANG_PREFIX);
  const lang = langMatch ? langMatch[1] : null;
  const stripped = lang ? path.replace(LANG_PREFIX, "/") || "/" : path;

  if (stripped === "/help") return prefixLang(lang, "/faq");
  if (stripped === "/feedback" || stripped === "/partners" || stripped === "/report-issue") {
    return prefixLang(lang, "/contact");
  }
  if (stripped === "/sitemap") return "/sitemap.xml";
  if (stripped === "/deals/all" || stripped === "/deals") return prefixLang(lang, "/coupons");

  const dealMatch = stripped.match(/^\/deal\/(.+)$/);
  if (dealMatch) return prefixLang(lang, `/coupon/${dealMatch[1]}`);

  return null;
}
